var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_273_132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 13.25C14.45 13.25 14 13.7 14 14.25V15.25H2V14.25C2 13.7 1.55 13.25 1 13.25C0.45 13.25 0 13.7 0 14.25V16.25C0 16.8 0.45 17.25 1 17.25H15C15.55 17.25 16 16.8 16 16.25V14.25C16 13.7 15.55 13.25 15 13.25Z",
    fill: "#004C97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.41988 12.07C7.58988 12.19 7.78988 12.25 7.99988 12.25C8.21988 12.25 8.42988 12.18 8.59988 12.05L12.5999 9.05C13.0399 8.72 13.1299 8.09 12.7999 7.65C12.4699 7.21 11.8399 7.12 11.3999 7.45L8.99988 9.26V1.25C8.99988 0.7 8.54988 0.25 7.99988 0.25C7.44988 0.25 6.99988 0.7 6.99988 1.25V9.25C6.99988 9.25 7.00988 9.3 7.00988 9.32L4.57988 7.62C4.12988 7.3 3.49988 7.41 3.18988 7.87C2.86988 8.32 2.97988 8.94 3.42988 9.26L7.42988 12.08L7.41988 12.07Z",
    fill: "#004C97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_273_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.37eb2ed4142439d0eb0c62bc54c17dcb.svg";
export { ForwardRef as ReactComponent };